<template>
<div class="chapter">
<div class="inner_page">
<p class="left"><a id="piv"></a> <span style="font-size: smaller">FIRST MARINER BOOKS EDITION 2003</span></p>
<p class="timebreak"> <br/></p>
<p class="left">Copyright © 1987 by Ward Just</p>
<p class="timebreak"> <br/></p>
<p class="left">All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="left">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="left"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="left">The Library of Congress has cataloged the print edition as follows:<br/>
Just, Ward S.<br/>
The American ambassador.<br/>
“A Richard Todd book”—<br/>
p. cm.<br/>
<span style="font-size: smaller">ISBN</span> 0-395-42694-4<br/>
<span style="font-size: smaller">ISBN</span> 0-618-34078-5 (pbk.)<br/>
I. Title.<br/>
<span style="font-size: smaller">PS</span>3560.<span style="font-size: smaller">U</span>75<span style="font-size: smaller">A</span>79 1987 813'.54 86-20126</p>
<p class="timebreak"> <br/></p>
<p class="left">eISBN 978-0-544-32660-6<br/>
v1.0214</p>
<p class="timebreak"> <br/></p>
<p class="left">An excerpt from this book originally appeared in the Winter 1986 issue of <em>TriQuarterly</em>, a publication of Northwestern University.</p>
<p class="timebreak"> <br/></p>
<p class="left">The quotation from Dylan Thomas’s “Do Not Go Gentle into That Good Night,” on <span href="#/c04#p92" title="Link target outside of Sample">[&gt;]</span>, is from <em>Poems of Dylan Thomas.</em> Copyright © 1952 by Dylan Thomas. Reprinted by permission of New Directions Publishing Corporation.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?71c45610